import {Controller, useFormContext} from 'react-hook-form';
import {useSchema} from 'context/guest';
import {FormTypes} from 'utils/guestForm';
import {getAgreementClausesData} from './getAgreementClausesData';
import {Checkbox, Container} from './styled';
import {FormFieldWrapper} from 'styled/common';

export const AgreementClauses = () => {
  const {agreementClauses} = useSchema();
  const {control} = useFormContext<FormTypes>();

  const agreementClausesItems = agreementClauses
    ?.filter(agreement => agreement.is_active)
    .map(getAgreementClausesData);

  return (
    !!agreementClausesItems?.length && (
      <Container>
        {agreementClausesItems.map(({name, body, required}) => (
          <FormFieldWrapper key={name}>
            <Controller
              rules={{required}}
              name={name}
              control={control}
              render={({field, fieldState: {error}}) => (
                <Checkbox label={body} error={error?.message} {...field} />
              )}
            />
          </FormFieldWrapper>
        ))}
      </Container>
    )
  );
};
